import { render, staticRenderFns } from "./PersonAddedToChatMessage.vue?vue&type=template&id=42877efa&scoped=true&"
import script from "./PersonAddedToChatMessage.vue?vue&type=script&lang=ts&"
export * from "./PersonAddedToChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./PersonAddedToChatMessage.vue?vue&type=style&index=0&id=42877efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42877efa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
